/* src/ui/hud/surveyPill.ts — "the crew is out surveying" indicator.
 *
 * Visible only while survey cells in the current view are queued or being fetched. It is the
 * one UI trace of the whole on-demand-Australia machinery: everything else is just the map
 * gaining blocks. Driven by the `world:surveys` event main.ts emits after each coverage
 * reconcile — this component owns no network and no state beyond the last count.
 */

import { on } from '../../core/events.ts';
import { el } from '../dom.ts';

export class SurveyPill {
  readonly #label = document.createTextNode('');
  readonly #root: HTMLElement;
  #off: (() => void) | null = null;

  constructor() {
    this.#root = el(
      'div',
      { class: 'gf-survey-pill is-hidden', attrs: { 'aria-live': 'polite' } },
      el('span', { class: 'gf-survey-pill-dot' }),
      this.#label,
    );
  }

  mount(parent: HTMLElement): void {
    parent.appendChild(this.#root);
    this.#off = on('world:surveys', ({ pending }) => {
      if (pending > 0) {
        // Surveys make blocks BUYABLE — the buildings themselves are already on screen from
        // the basemap. The copy says so, or the pill reads as "wait for the map to appear".
        this.#label.textContent =
          pending === 1
            ? 'Making 1 block buyable…'
            : `Making ${String(pending)} blocks buyable…`;
        this.#root.classList.remove('is-hidden');
      } else {
        this.#root.classList.add('is-hidden');
      }
    });
  }

  unmount(): void {
    this.#off?.();
    this.#off = null;
    this.#root.remove();
  }
}
